export const routeTableSampleRoutes = [
  {
    routeId: "",
    environment: "production",
    method: "GET",
    route: "/",
    noticeCount: 20,
    total: {
      responseCodesBarData: {
        success: 18640642,
        redirection: 5829,
        clientError: 1961,
        serverError: 406,
      },
      requestRate: 143.895354938272,
      count: 18648838,
      mean: 84.1987,
      stddev: 0.0942667,
      p50: 72.3749,
      p90: 133.4,
      p95: 168.42,
      p99: 224.504,
    },
    errorRate: 0.00000001,
  },
  {
    routeId: "",
    environment: "production",
    method: "GET",
    route: "/projects/:project_id(.:format)",
    noticeCount: 51000,
    total: {
      responseCodesBarData: {
        success: 6204434,
        redirection: 4285,
        clientError: 3631,
        serverError: 93,
      },
      requestRate: 47.9355169753086,
      count: 6212443,
      mean: 25.174,
      stddev: 0.0579,
      p50: 21.515,
      p90: 35.9526,
      p95: 46.7644,
      p99: 73.5564,
    },
    errorRate: 0.00822,
  },
  {
    routeId: "",
    environment: "production",
    method: "GET",
    route: "/projects(.:format)",
    noticeCount: 40,
    total: {
      responseCodesBarData: {
        success: 2907204,
        redirection: 0,
        clientError: 471,
        serverError: 3569,
      },
      requestRate: 22.4633024691358,
      count: 2911244,
      mean: 38.885,
      stddev: 0.0954444,
      p50: 33.5242,
      p90: 54.8414,
      p95: 70.5689,
      p99: 109.638,
    },
    errorRate: 0.00000001,
  },
  {
    routeId: "",
    environment: "production",
    method: "GET",
    route: "/users(.:format)",
    noticeCount: 5,
    total: {
      responseCodesBarData: {
        success: 1678299,
        redirection: 0,
        clientError: 445,
        serverError: 45,
      },
      requestRate: 12.9536188271605,
      count: 1678789,
      mean: 68.0525,
      stddev: 0.227933,
      p50: 59.3044,
      p90: 101.189,
      p95: 130.87,
      p99: 192.773,
    },
    errorRate: 0.000001,
  },
  {
    routeId: "",
    environment: "production",
    method: "GET",
    route: "/users/:user_id(.:format)",
    noticeCount: 3,
    total: {
      responseCodesBarData: {
        success: 1498082,
        redirection: 0,
        clientError: 243,
        serverError: 40,
      },
      requestRate: 11.5614583333333,
      count: 1498365,
      mean: 20.7854,
      stddev: 0.0735444,
      p50: 17.8136,
      p90: 29.6138,
      p95: 37.9672,
      p99: 59.1819,
    },
    errorRate: 0.0000001,
  },
  {
    routeId: "",
    environment: "production",
    method: "GET",
    route: "/accounts(.:format)",
    noticeCount: 0,
    total: {
      responseCodesBarData: {
        success: 1235160,
        redirection: 0,
        clientError: 119,
        serverError: 32,
      },
      requestRate: 9.53172067901235,
      count: 1235311,
      mean: 40.4254,
      stddev: 0.184322,
      p50: 34.5604,
      p90: 60.0568,
      p95: 78.6748,
      p99: 124.944,
    },
    errorRate: 0,
  },
  {
    routeId: "",
    environment: "production",
    method: "GET",
    route: "/accounts/:account_id(.:format)",
    noticeCount: 1,
    total: {
      responseCodesBarData: {
        success: 770432,
        redirection: 236,
        clientError: 521,
        serverError: 40,
      },
      requestRate: 5.95084104938272,
      count: 771229,
      mean: 25.1439,
      stddev: 0.198644,
      p50: 21.5858,
      p90: 35.54,
      p95: 46.0487,
      p99: 71.2808,
    },
    errorRate: 0.0000001,
  },
  {
    routeId: "",
    environment: "production",
    method: "GET",
    route: "/users/:user_id/edit(.:format)",
    noticeCount: 12009,
    total: {
      responseCodesBarData: {
        success: 701873,
        redirection: 100,
        clientError: 417,
        serverError: 6,
      },
      requestRate: 5.41972222222222,
      count: 702396,
      mean: 48.179,
      stddev: 0.435789,
      p50: 39.2574,
      p90: 79.351,
      p95: 102.337,
      p99: 146.516,
    },
    errorRate: 0.017,
  },
  {
    routeId: "",
    environment: "production",
    method: "GET",
    route: "/accounts/:account_id/edit",
    noticeCount: 2,
    total: {
      responseCodesBarData: {
        success: 595911,
        redirection: 391,
        clientError: 446,
        serverError: 3,
      },
      requestRate: 4.60456018518519,
      count: 596751,
      mean: 18.0997,
      stddev: 0.536478,
      p50: 11.7905,
      p90: 28.7048,
      p95: 49.1026,
      p99: 83.6156,
    },
    errorRate: 0.00001,
  },
  {
    routeId: "",
    environment: "production",
    method: "POST",
    route: "/users/create(.:format)",
    noticeCount: 12000,
    total: {
      responseCodesBarData: {
        success: 8061,
        redirection: 0,
        clientError: 503002,
        serverError: 33,
      },
      requestRate: 3.94364197530864,
      count: 511096,
      mean: 52.7288,
      stddev: 1.85592,
      p50: 44.4907,
      p90: 91.7213,
      p95: 127.076,
      p99: 264.255,
    },
    errorRate: 0.0234,
  },
] as any;
